import { createSlice } from "@reduxjs/toolkit";

import { getEducationInfoRes } from "core/http/service/personnelInformation/resTypes";

import { set, uniqueId } from "lodash";

interface InitialState {
  currentData: getEducationInfoRes;
  formData: getEducationInfoRes;
  changedData: {
    [key: string]: any;
  };
}

const initialState: InitialState = {
  currentData: {
    education: [],
    languages: [
      {
        foreignLanguageName: "",
        degreeLevelName: "",
        transOrganizationName: "",
      },
    ],
    certificates: [],
    certificateOthers: [],
    professionalCertificates: [],
  },
  formData: {
    education: [],
    languages: [
      {
        foreignLanguageName: "",
        degreeLevelName: "",
        transOrganizationName: "",
      },
    ],
    certificates: [],
    certificateOthers: [],
    professionalCertificates: [],
  },
  changedData: undefined,
};

const formEditEducationInformationSlice = createSlice({
  name: "formEditMaritalInformation",
  initialState,
  reducers: {
    updateFormEditEducationInformation: (state, action) => {
      const keys = Object.keys(action.payload);
      for (let i = 0; i < keys.length; i++) {
        set(state.formData, keys[i], action.payload[keys[i]]);
      }
    },
    updateCurrentData: (state, action) => {
      state.currentData = action.payload;
    },
    addMoreEducationInfo: (state) => {
      state.formData.education = [
        ...(state.formData.education ?? []),
        {
          uuid: uniqueId(),
          degreeName: "",
          specializedName: "",
          transOrganizationName: "",
          classificationName: "",
          formOfTrainingName: "",
          graduationYear: "",
          trainingOrgOtherName: "",
        },
      ];
    },
    removeLastItemEducationInfo: (state, action) => {
      state.formData.education.splice(action.payload, 1);
    },

    addMoreCertificationInfo: (state) => {
      state.formData.certificateOthers = [
        ...(state.formData.certificateOthers ?? []),
        {
          uuid: uniqueId(),
          practiceCertificateName: "",
          certificateNo: "",
          effectiveDate: "",
          issuedDate: "",
          certificateType: "",
        },
      ];
    },
    addMoreLanguageInfo: (state) => {
      state.formData.languages = [
        ...(state.formData.languages ?? []),
        {
          uuid: uniqueId(),
          foreignLanguageName: "",
          degreeLevelName: "",
          transOrganizationName: "",
        },
      ];
    },
    removeLastItemCertificationInfo: (state, action) => {
      state.formData.certificateOthers.splice(action.payload, 1);
    },
    addMoreCertificationProfessionalInfo: (state) => {
      state.formData.professionalCertificates = [
        ...(state.formData.professionalCertificates ?? []),
        {
          uuid: uniqueId(),
          certificateName: "",
          code: "",
          expireDate: "",
          files: [],
          issueDate: "",
          levelName: "",
          note: "",
          specializedFieldName: "",
          transOrganizationName: "",
        },
      ];
    },
    removeLastItemCertificationProfessionalInfo: (state, action) => {
      state.formData.professionalCertificates.splice(action.payload, 1);
    },
    removeLastItemLanguageInfo: (state, action) => {
      state.formData.languages.splice(action.payload, 1);
    },
    updateChangedData: (state, action) => {
      state.changedData = action.payload;
    },
    resetFormEditEductionInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  updateCurrentData,
  updateFormEditEducationInformation,
  addMoreEducationInfo,
  removeLastItemEducationInfo,
  addMoreCertificationInfo,
  resetFormEditEductionInformation,
  removeLastItemCertificationInfo,
  updateChangedData,
  addMoreLanguageInfo,
  removeLastItemLanguageInfo,
  addMoreCertificationProfessionalInfo,
  removeLastItemCertificationProfessionalInfo,
} = formEditEducationInformationSlice.actions;

export default formEditEducationInformationSlice.reducer;
